function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, memo } from 'react';

/**
 * Permet d'afficher la description dans une iframe qui se taille (hauteur)
 * tout seul en fonction du texte.
 */
var QuestionDescription = function QuestionDescription(props) {
  var text = props.text,
    setParentStyle = props.setParentStyle;
  var frameRef = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    frameHeight = _useState2[0],
    setFrameHeight = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    currentText = _useState4[0],
    setText = _useState4[1];
  var _useState5 = useState('no-frame'),
    _useState6 = _slicedToArray(_useState5, 2),
    styleDescription = _useState6[0],
    setStyleDescription = _useState6[1];
  useEffect(function () {
    if (!text) {
      return function () {
        setText(null);
      };
    }
    var tmpText = "\n      <link href=\"https://fonts.googleapis.com/css2?family=Roboto&display=swap\" rel=\"stylesheet\">\n      <style>\n          body,p {\n             font-family: \"Roboto\";\n             text-align: center;\n          }\n      </style> \n      ".concat(text, "\n    ");
    setText(tmpText);
  }, [text]);
  useEffect(function () {
    var _frameRef$current;
    if (!frameRef || !frameRef.current) {
      return;
    }
    if (((_frameRef$current = frameRef.current) === null || _frameRef$current === void 0 || (_frameRef$current = _frameRef$current.contentWindow) === null || _frameRef$current === void 0 || (_frameRef$current = _frameRef$current.document) === null || _frameRef$current === void 0 || (_frameRef$current = _frameRef$current.children[0]) === null || _frameRef$current === void 0 ? void 0 : _frameRef$current.offsetHeight) > 0) {
      setFrameHeight(frameRef.current.contentWindow.document.children[0].offsetHeight + 20);
      setStyleDescription('mb-4 py-1');
      setParentStyle('mb-4');
    }
    frameRef.current.addEventListener('load', function (e) {
      setFrameHeight(frameRef.current.contentWindow.document.children[0].offsetHeight + 20);
      setStyleDescription('mb-4 py-1');
      setParentStyle('mb-4');
    });
  }, [frameRef, currentText]);
  if (!currentText) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "collectorQuestionDescription ".concat(styleDescription)
  }, /*#__PURE__*/React.createElement("iframe", {
    ref: frameRef,
    title: "descr",
    id: "descr-frame",
    srcDoc: currentText,
    style: {
      width: '100%',
      height: "".concat(frameHeight, "px")
    }
  }));
};
export default /*#__PURE__*/memo(QuestionDescription);